import React, { memo } from 'react';
import SVG from 'react-inlinesvg';

import ImageHelper from '~/helpers/ImageHelper';

interface QIconProps {
  src: string;
  size?: number;
  color?: string;
}

export const QSvgIcon: React.FC<QIconProps> = memo((props) => {
  return (
    <SVG
      src={props.src}
      width={props.size ?? 24}
      height={props.size ?? 24}
      preProcessor={(code) =>
        ImageHelper.preProcessor(code, {
          stroke: props.color ?? 'currentColor',
          fill: props.color ?? 'currentColor',
        })
      }
    />
  );
});
